import { render } from "./BagPitTypeForm.vue?vue&type=template&id=bbeaaf12"
import script from "./BagPitTypeForm.vue?vue&type=script&lang=js"
export * from "./BagPitTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__